export const version = '2.11.10';
//# sourceMappingURL=version.js.map